// styles.js
import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
               page: {
                   paddingTop: 10,
                   flexDirection: 'row',
                   backgroundColor: '#FFFFFF',
                   justifyContent: 'center', // Center horizontally
                   marginLeft: 10, // Increase the left margin
                   marginRight: 13
       
               },
               pageWithMargin: {
                   backgroundColor: "lightblue"
               },
               header: {
                   position: 'absolute',
                   top: 0, // Adjust this value to change the vertical position
                   left: 0,
                   right: 0,
                   textAlign: 'center',
               },
               loading: {
                   display: 'flex',
                   flexDirection: 'column',
                   width: '100vw',
                   height: '100vh',
                   justifyContent: 'center',
                   alignItems: 'center'
               },
               tableContainer: {
                   display: 'flex',
                   flexDirection: 'row',
                   width: '100vw',
                   justifyContent: 'space-between',
               },
               table: {
                   display: 'table',
                   width: 'auto', // Adjust as needed to fit four tables in a row
                   margin: 5,
                   marginLeft: -1,
               },
               tableone: {
                   display: 'table',
                   width: '18%', // Adjust as needed to fit four tables in a row
                   margin: 5,
               },
               tableCellone: {
                   border: '0.5px solid lightgray',
                   padding: 0.5,
                   fontSize: 8,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'right',
                   paddingRight: 3,
                   flex: 1, // Remove width and use flex to distribute space equally
               },
       
               tableCellonebig: {
                   border: '0.5px solid lightgray',
                   fontSize: 9.5,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'center',
                   width: '85mm', // Set the width of the individual cell
                   fontWeight: 'bold'
               },
               tableCellonebig2: {
                   border: '0.5px solid #000',
                   fontSize: 9.5,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'right',
                   paddingRight: '10px',
                   width: '85mm', // Set the width of the individual cell
                   fontWeight: 'bold'
               },
               tableCellonebigdata: {
                   border: '0.5px solid lightgray',
                   fontSize: 10,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'right',
                   paddingRight: '3mm',
                   width: '85mm', // Set the width of the individual cell
                   fontWeight: 'bold'
               },
               tableRowone: {
                   flexDirection: 'row',
                   width: '65%',
                   height: 17,
                   textAlign: 'right',
                   marginLeft: -5,
               },
               tableRowonebig: {
                   flexDirection: 'row',
                   width: '80%',
                   height: 17,
                   textAlign: 'right',
                   marginLeft: -5,
               },
               tableHeaderone: {
                   flexDirection: 'row',
                   width: '65%',
                   height: 17,
                   textAlign: 'right',
                   border: '0.5px solid #000',
                   marginLeft: -5,
                   backgroundColor: 'lightgray'
               },
               tableHeaderonebig: {
                   flexDirection: 'row',
                   width: '80%',
                   height: 17,
                   textAlign: 'right',
                   border: '0.5px solid #000',
                   marginLeft: -5,
                   backgroundColor: 'lightgray'
               },
               allbill: {
                   flexDirection: 'row',
                   width: '65%',
                   textAlign: 'right',
                   height: 17,
                   marginLeft: -5,
                   backgroundColor: 'lightgray',
                   marginTop: 5
               },
               allbillbig: {
                   border: '0.5px solid lightgray',
                   flexDirection: 'row',
                   width: '80%',
                   textAlign: 'right',
                   height: 17,
                   marginLeft: -5,
                   backgroundColor: 'lightgray',
                   marginTop: 5
               },
               tableRow: {
                   flexDirection: 'row',
                   height: 17,
                   marginLeft: 3,
       
               },
               tableRow2: {
                   flexDirection: 'row',
                   height: 17,
                   marginLeft: 3,
                   marginTop: 5,
                   backgroundColor: 'lightgray'
               },
               line: {
                   flexDirection: 'row',
                   backgroundColor: 'lightgray',
                   height: 1,
                   marginTop: 2,
                   width: '95vw',
               },
               tableHeader: {
                   border: '0.5px solid #000',
                   padding: 0.5,
                   fontSize: 8,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'center',
                   width: '5mm', // Set the width of the individual cell
                   backgroundColor: 'lightgray',
               },
               tableHeadersm: {
                   border: '0.5px solid #000',
                   fontSize: 8,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'center',
                   width: '11mm', // Set the width of the individual cell
                   backgroundColor: 'lightgray',
               },
               tableHeadersmbig: {
                   border: '0.5px solid #000',
                   fontSize: 10,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'center',
                   width: '14mm', // Set the width of the individual cell
                   backgroundColor: 'lightgray',
               },
               tableHeadersmbig2: {
                   border: '0.5px solid #000',
                   fontSize: 10,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'center',
                   width: '13mm', // Set the width of the individual cell
                   backgroundColor: 'lightgray',
               },
               tableHeadersmbig3: {
                   border: '0.5px solid #000',
                   fontSize: 10,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'right',
                   paddingRight: 2,
                   width: '19mm', // Set the width of the individual cell
                   backgroundColor: 'lightgray',
               },
                  tableHeadersmbigall: {
                   border: '0.5px solid #000',
                   fontSize: 10,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'right',
                   paddingRight: 2,
                   width: '30mm', // Set the width of the individual cell
                   backgroundColor: 'lightgray',
               },
               tableHeadermed: {
                   border: '0.5px solid #000',
                   padding: 0.5,
                   fontSize: 8,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'center',
                   width: '13mm', // Set the width of the individual cell
                   backgroundColor: 'lightgray',
               },
               tableHeadermedbig: {
                   border: '0.5px solid #000',
                   padding: 0.5,
                   fontSize: 9,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'center',
                   width: '13mm', // Set the width of the individual cell
                   backgroundColor: 'lightgray',
               },
               tableHeadermed2: {
                   border: '0.5px solid #000',
                   padding: 0.5,
                   fontSize: 8,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'center',
                   width: '19mm', // Set the width of the individual cell
                   backgroundColor: 'lightgray',
               },
               tableHeadermed2big: {
                   border: '0.5px solid #000',
                   padding: 0.5,
                   fontSize: 10,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'center',
                   width: '19mm', // Set the width of the individual cell
                   backgroundColor: 'lightgray',
               },
               tableCell: {
                   border: '0.5px solid lightgray',
                   fontSize: 8,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'center',
                   width: '1mm', // Set the width of the individual cell
               },
               tableCellbig: {
                   border: '0.5px solid lightgray',
                   fontSize: 10,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'center',
                   width: '1mm', // Set the width of the individual cell
               },
               tableCellsm: {
                   border: '0.5px solid lightgray',
                   fontSize: 8,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'center',
                   width: '11mm', // Set the width of the individual cell
               },
               tableCellsmamt: {
                   border: '0.5px solid lightgray',
                   fontSize: 8,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'right',
                   paddingRight: 2,
                   width: '18mm', // Set the width of the individual cell
       
               },
               tableCellsmbig: {
                   border: '0.5px solid lightgray',
                   fontSize: 10,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'center',
                   width: '14mm', // Set the width of the individual cell
       
               },
               tableCellmed: {
                   border: '0.5px solid lightgray',
                   fontSize: 8,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'right',
                   paddingRight: '1mm',
                   width: '13mm', // Set the width of the individual cell
               },
               tableCellmedbig: {
                   border: '0.5px solid lightgray',
                   fontSize: 10,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'right',
                   paddingRight: '1mm',
                   width: '13mm', // Set the width of the individual cell
               },
               tableCellmed2: {
                   border: '0.5px solid lightgray',
                   fontSize: 8,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'right',
                   paddingRight: '1mm',
                   width: '19mm', // Set the width of the individual cell
               },
               tableCellmed2big: {
                   border: '0.5px solid lightgray',
                   fontSize: 10,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'right',
                   paddingRight: '1mm',
                   width: '19mm', // Set the width of the individual cell
               },
                tableCellmed2bigall: {
                   border: '0.5px solid lightgray',
                   fontSize: 10,
                   fontFamily: 'Lato-Italic',
                   textAlign: 'right',
                   paddingRight: '1mm',
                   width: '30mm', // Set the width of the individual cell
               },
               latoText: {
                   fontFamily: 'Lato-Italic',
                   fontSize: 15,
                   marginBottom: 5,
                   textAlign: 'center',
                   width: '100%',
                   fontWeight: 'bold',
                   marginLeft: -15,
                   marginTop: 1,
               },
               headtextsmall: {
                   fontFamily: 'Lato-Italic',
                   fontSize: 10,
                   fontWeight: 'bold',
               },
               headtextsmall2: {
                   fontFamily: 'Lato-Italic',
                   fontSize: 14,
                   marginLeft: 20,
                   marginTop: -5,
                   fontWeight: 'bold',
               },
               headtextsmall3: {
                   fontFamily: 'Lato-Italic',
                   fontSize: 14,
                   color: 'rgb(156, 44, 24)',
                   fontWeight: 'bold',
                   alignSelf: 'center'
               },
               headtextsmall4: {
                   fontFamily: 'Lato-Italic',
                   fontSize: 10,
                   color: 'rgb(156, 44, 24)',
                   fontWeight: 'bold',
                   alignSelf: 'center'
               },
               headtextsmallleft1: {
                   fontFamily: 'Lato-Italic',
                   fontSize: 9,
                   marginLeft: -70,
                   marginTop: -5,
                   fontWeight: 'bold',
               },
               headtextsmallleft2: {
                   fontFamily: 'Lato-Italic',
                   fontSize: 9,
                   marginLeft: 0,
                   marginTop: -5,
                   fontWeight: 'bold',
               },
               headtextsmallleft3: {
                   fontFamily: 'Lato-Italic',
                   fontSize: 9,
                   marginLeft: 0,
                   marginTop: -5,
                   fontWeight: 'bold',
               },
               headtextsmallleft4: {
                   fontFamily: 'Lato-Italic',
                   fontSize: 9,
                   marginRight: -50,
                   marginTop: -5,
                   fontWeight: 'bold',
               },
       
               headtextsmallleft1big: {
                   fontFamily: 'Lato-Italic',
                   fontSize: 11,
                   marginLeft: -70,
                   marginTop: -5,
                   fontWeight: 'bold',
               },
               headtextsmallleft2big: {
                   fontFamily: 'Lato-Italic',
                   fontSize: 11,
                   marginLeft: 0,
                   marginTop: -5,
                   fontWeight: 'bold',
               },
       
               row: {
                   display: 'flex',
                   flexDirection: 'row',
                   width: '95vw',
               },
               row1: {
                   display: 'flex',
                   flexDirection: 'row',
                   width: '95vw',
                   justifyContent: 'space-between',
                   alignItems: 'center',
                   marginTop: 5
               },
               row2: {
                   display: 'flex',
                   flexDirection: 'row',
                   width: '95vw',
                   justifyContent: 'space-between',
                   alignItems: 'center',
                   paddingLeft: 140,
                   paddingRight: 140,
                   backgroundColor: 'lightgray',
               },
               row2both: {
                   display: 'flex',
                   flexDirection: 'row',
                   width: '95vw',
                   justifyContent: 'space-between',
                   alignItems: 'center',
                   paddingLeft: 180,
                   paddingRight: 180,
                   backgroundColor: 'lightgray',
               },
               row2single: {
                   display: 'flex',
                   flexDirection: 'row',
                   width: '95vw',
                   justifyContent: 'space-between',
                   alignItems: 'center',
                   paddingLeft: '250px',
                   backgroundColor: 'lightgray',
               },
               column1: {
                   display: 'flex',
                   flexDirection: 'column',
                   width: '15%',
                   justifyContent: 'start',
                   alignItems: 'flex-start', // Align text to the left
                   paddingLeft: 5,
                   paddingRight: 5,
                   marginLeft: 10,
                   border: '0.5px solid black',
               },
               column1noborder: {
                   display: 'flex',
                   flexDirection: 'column',
                   width: '23%',
                   justifyContent: 'start',
                   alignItems: 'flex-start', // Align text to the left
                   paddingLeft: 5,
                   paddingRight: 5,
                   marginLeft: 10,
               },
               column2: {
                   display: 'flex',
                   flexDirection: 'column',
                   width: '15%',
                   justifyContent: 'start',
                   alignItems: 'flex-start', // Align text to the left
                   paddingLeft: 5,
                   paddingRight: 5,
                   marginLeft: 5,
                   border: '0.5px solid black',
       
               },
               column2noborder: {
                   display: 'flex',
                   flexDirection: 'column',
                   width: '15%',
                   justifyContent: 'start',
                   alignItems: 'flex-start', // Align text to the left
                   paddingLeft: 5,
                   paddingRight: 5,
                   marginLeft: 5
               },
               column3: {
                   display: 'flex',
                   flexDirection: 'column',
                   width: '15%',
                   paddingLeft: 3,
                   paddingRight: 3,
                   justifyContent: 'start',
                   alignItems: 'flex-start', // Align text to the left
                   border: '0.5px solid black',
                   marginLeft: 7,
               },
               column3noborder: {
                   display: 'flex',
                   flexDirection: 'column',
                   width: '15%',
                   paddingLeft: 3,
                   paddingRight: 3,
                   justifyContent: 'start',
                   alignItems: 'flex-start', // Align text to the left
                   marginLeft: 7,
               },
               column1Row: {
                   display: 'flex',
                   flexDirection: 'row',
                   justifyContent: 'space-between',
                   alignItems: 'center',
                   width: '100%',
               },
               column1Rowratib: {
                   display: 'flex',
                   flexDirection: 'row',
                   justifyContent: 'space-between',
                   alignItems: 'center',
                   width: '100%',
                   marginTop: -5,
               },
               column1Rowratib2: {
                   display: 'flex',
                   flexDirection: 'row',
                   justifyContent: 'space-between',
                   alignItems: 'center',
                   width: '100%',
                   marginTop: -5,
                   marginBottom: 3
               },
               simplerow: {
                   display: 'flex',
                   flexDirection: 'row',
                   justifyContent: 'center',
                   alignItems: 'center',
                   width: '20%',
               },
               simplecol: {
                   display: 'flex',
                   flexDirection: 'column',
                   justifyContent: 'center',
                   alignItems: 'center',
                   width: '100%',
                   marginTop: 0
               },
               column1Rowgray: {
                   display: 'flex',
                   flexDirection: 'row',
                   justifyContent: 'space-between',
                   alignItems: 'center',
                   width: '100%',
                   paddingLeft: 4,
                   marginTop: 0,
                   marginBottom: 1,
                   border: '0.5px solid black',
                   backgroundColor: 'lightgray'
               },
               column1Label: {
                   fontFamily: 'Lato-Italic',
                   fontSize: 9,
                   fontWeight: 'bold',
                   textAlign: 'left', // Align labels to the left
               },
               column1Labelcenter2: {
                   fontFamily: 'Lato-Italic',
                   fontSize: 10,
                   fontWeight: 'bold',
                   alignSelf: 'center',
                   textAlign: 'center', // Align labels to the left
               },
               column1Value: {
                   fontFamily: 'Lato-Italic',
                   fontSize: 9,
                   fontWeight: 'bold',
                   textAlign: 'right', // Align values to the right
               },
               pageBreak: {
                   pageBreakBefore: 'always',
               },
               totalsRow: {
                   flexDirection: 'row',
                   borderTop: '1px solid #000',
                   paddingTop: 5,
                   paddingLeft: 2,
               },
               totalsCell: {
                   border: '0.5px solid lightgray',
                   padding: 0.5,
                   flex: 1,
                   fontSize: 8,
                   width: 2,
                   textAlign: 'center',
               },
               imagerow: {
                   display: 'flex',
                   flexDirection: 'row',
                   width: '95vw',
                   justifyContent: 'space-between',
                   alignItems: 'center',
                   marginTop: -4
               },
               image: {
                   width: 45, // Adjust the width as needed
                   height: "auto", // Maintain aspect ratio
                   marginLeft: -5,
                   marginTop: 5
       
               },
               imgtext: {
                   fontFamily: 'Lato-Italic',
                   fontSize: 8,
                   fontWeight: 'bold',
                   textAlign: 'center', // Align labels to the left
               },
               tableCellgreen: {
                   border: '0.5px solid lightgray',
                   padding: 0.5,
                   flex: 1,
                   fontSize: 12,
                   fontWeight: 'bold',
                   fontFamily: 'Lato-Italic',
                   color: 'green',
                   width: 2,
                   fontWeight: 'bold',
                   textAlign: 'center',
               },
               tableCellred: {
                   border: '0.5px solid lightgray',
                   padding: 0.5,
                   flex: 1,
                   fontSize: 12,
                   fontWeight: 'bold',
                   fontFamily: 'Lato-Italic',
                   color: 'red',
                   width: 3,
                   fontWeight: 'bold',
                   textAlign: 'center',
               },
               loadingSpinner: {
                   position: 'absolute',
                   top: '50%',
                   left: '50%',
                   transform: 'translate(-50%, -50%)',
                   fontSize: 16,
                   fontWeight: 'bold',
                   color: 'gray',
               },
          
    });